// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // import { jwtDecode } from "jwt-decode";
// // import { TextField, Button, Typography, Box, Chip, CircularProgress } from "@mui/material";

// // export default function Profile() {
// //   const [student, setStudent] = useState(null);
// //   const [formData, setFormData] = useState({});
// //   const [editMode, setEditMode] = useState(false);
// //   const [loading, setLoading] = useState(true);
// //   const [saving, setSaving] = useState(false);

// //   // ✅ Fetch logged-in user details
// //   useEffect(() => {
// //     const fetchProfile = async () => {
// //       try {
// //         const token = localStorage.getItem("token");
// //         if (!token) return;

// //         const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/me`, {
// //           headers: { Authorization: `Bearer ${token}` },
// //         });

// //         setStudent(res.data);
// //         setFormData(res.data);
// //       } catch (error) {
// //         console.error("Error fetching profile:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchProfile();
// //   }, []);

// //   // ✅ Handle field changes
// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData({ ...formData, [name]: value });
// //   };

// //   // ✅ Save profile updates
// //   const handleSave = async () => {
// //     try {
// //       setSaving(true);
// //       const token = localStorage.getItem("token");

// //       const response = await axios.put(
// //         `${process.env.REACT_APP_API_URL}/api/users/update`,
// //         formData,
// //         {
// //           headers: { Authorization: `Bearer ${token}` },
// //         }
// //       );

// //       alert("Profile updated successfully!");
// //       setStudent(response.data.user);
// //       setFormData(response.data.user);
// //       setEditMode(false);
// //     } catch (error) {
// //       console.error("Error updating profile:", error);
// //       alert("Failed to update profile");
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <Box className="flex justify-center items-center min-h-screen">
// //         <CircularProgress />
// //       </Box>
// //     );
// //   }

// //   if (!student) {
// //     return <Typography align="center">No profile found</Typography>;
// //   }

// //   return (
// //     <Box className="flex flex-col items-center justify-center min-h-screen p-6">
// //       <Box className="bg-white shadow-md rounded-2xl p-6 w-full max-w-lg">
// //         <Typography variant="h4" className="mb-4 text-center font-bold">
// //           Student Profile
// //         </Typography>

// //         {/* Username */}
// //         <TextField
// //           label="Username"
// //           name="username"
// //           value={formData.username || ""}
// //           onChange={handleChange}
// //           fullWidth
// //           margin="normal"
// //           disabled={!editMode}
// //         />

// //         {/* Email */}
// //         <TextField
// //           label="Email"
// //           name="email"
// //           value={formData.email || ""}
// //           onChange={handleChange}
// //           fullWidth
// //           margin="normal"
// //           disabled
// //         />

// //         {/* Department */}
// //         <TextField
// //           label="Department"
// //           name="department"
// //           value={formData.department || ""}
// //           onChange={handleChange}
// //           fullWidth
// //           margin="normal"
// //           disabled={!editMode}
// //         />

// //         {/* Subjects */}
// //         {!editMode ? (
// //           <Box className="flex flex-wrap gap-2 my-3">
// //             {formData.subjects?.length > 0 ? (
// //               formData.subjects.map((sub, index) => (
// //                 <Chip key={index} label={sub} color="primary" />
// //               ))
// //             ) : (
// //               <Typography>No subjects assigned</Typography>
// //             )}
// //           </Box>
// //         ) : (
// //           <TextField
// //             label="Subjects (comma separated)"
// //             name="subjects"
// //             value={formData.subjects?.join(", ") || ""}
// //             onChange={(e) =>
// //               setFormData({ ...formData, subjects: e.target.value.split(",").map((s) => s.trim()) })
// //             }
// //             fullWidth
// //             margin="normal"
// //           />
// //         )}

// //         {/* Buttons */}
// //         <Box className="flex justify-center gap-4 mt-4">
// //           {!editMode ? (
// //             <Button variant="contained" onClick={() => setEditMode(true)}>
// //               Edit Profile
// //             </Button>
// //           ) : (
// //             <>
// //               <Button
// //                 variant="contained"
// //                 color="success"
// //                 onClick={handleSave}
// //                 disabled={saving}
// //               >
// //                 {saving ? "Saving..." : "Save"}
// //               </Button>
// //               <Button
// //                 variant="outlined"
// //                 color="error"
// //                 onClick={() => {
// //                   setFormData(student);
// //                   setEditMode(false);
// //                 }}
// //               >
// //                 Cancel
// //               </Button>
// //             </>
// //           )}
// //         </Box>
// //       </Box>
// //     </Box>
// //   );
// // }


// import React, { useEffect, useState } from "react";
// import axios from "axios";

// export default function Profile() {
//   const [student, setStudent] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [editMode, setEditMode] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

//   // Fetch logged-in user details
//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) return;

//         const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
//         const res = await axios.get(`${apiUrl}/api/users/me`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         setStudent(res.data);
//         setFormData(res.data);
//       } catch (error) {
//         console.error("Error fetching profile:", error);
//         setSnackbar({ open: true, message: 'Failed to load profile data.', severity: 'error' });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProfile();
//   }, []);

//   // Handle field changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // Save profile updates
//   const handleSave = async () => {
//     try {
//       setSaving(true);
//       const token = localStorage.getItem("token");
//       const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

//       const response = await axios.put(
//         `${apiUrl}/api/users/update`,
//         formData,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       setSnackbar({ open: true, message: 'Profile updated successfully!', severity: 'success' });
//       setStudent(response.data.user);
//       setFormData(response.data.user);
//       setEditMode(false);
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       setSnackbar({ open: true, message: 'Failed to update profile. Please try again.', severity: 'error' });
//     } finally {
//       setSaving(false);
//     }
//   };

//   const closeSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const getInitials = (name) => {
//     return name
//       ? name
//           .split(' ')
//           .map(word => word.charAt(0).toUpperCase())
//           .join('')
//           .slice(0, 2)
//       : 'U';
//   };

//   if (loading) {
//     return (
//       <div className="profile-container">
//         <style>{`
//           @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
          
//           .profile-container {
//             min-height: 100vh;
//             background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
//           }

//           .loading-container {
//             text-align: center;
//             color: white;
//           }

//           .loading-spinner {
//             width: 48px;
//             height: 48px;
//             border: 4px solid rgba(255, 255, 255, 0.3);
//             border-top: 4px solid white;
//             border-radius: 50%;
//             animation: spin 1s linear infinite;
//             margin: 0 auto 1rem;
//           }

//           .loading-text {
//             font-size: 1.1rem;
//             font-weight: 500;
//           }

//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}</style>
//         <div className="loading-container">
//           <div className="loading-spinner"></div>
//           <div className="loading-text">Loading profile...</div>
//         </div>
//       </div>
//     );
//   }

//   if (!student) {
//     return (
//       <div className="profile-container">
//         <style>{`
//           @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
          
//           .profile-container {
//             min-height: 100vh;
//             background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
//           }

//           .error-container {
//             text-align: center;
//             color: white;
//             background: rgba(255, 255, 255, 0.1);
//             padding: 3rem;
//             border-radius: 16px;
//             backdrop-filter: blur(10px);
//           }

//           .error-icon {
//             width: 80px;
//             height: 80px;
//             background: rgba(239, 68, 68, 0.2);
//             border-radius: 50%;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             margin: 0 auto 1.5rem;
//             color: #fca5a5;
//           }

//           .error-title {
//             font-size: 1.5rem;
//             font-weight: 700;
//             margin-bottom: 0.5rem;
//           }

//           .error-message {
//             font-size: 1rem;
//             opacity: 0.9;
//           }
//         `}</style>
//         <div className="error-container">
//           <div className="error-icon">
//             <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"/>
//             </svg>
//           </div>
//           <div className="error-title">Profile Not Found</div>
//           <div className="error-message">Unable to load your profile information. Please try refreshing the page.</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="profile-container">
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
//         .profile-container {
//           min-height: 100vh;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           position: relative;
//           overflow: hidden;
//           padding: 2rem 1rem;
//           font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .profile-container::before {
//           content: '';
//           position: absolute;
//           top: 15%;
//           right: 10%;
//           width: 120px;
//           height: 120px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.08);
//           animation: float 4s ease-in-out infinite;
//         }

//         .profile-container::after {
//           content: '';
//           position: absolute;
//           bottom: 20%;
//           left: 12%;
//           width: 90px;
//           height: 90px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.05);
//           animation: float 3.5s ease-in-out infinite;
//           animation-delay: 1.8s;
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-15px) rotate(8deg); }
//         }

//         @keyframes slideIn {
//           from { opacity: 0; transform: translateY(30px); }
//           to { opacity: 1; transform: translateY(0); }
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @keyframes slideInFromBottom {
//           from { 
//             opacity: 0; 
//             transform: translateY(100px); 
//           }
//           to { 
//             opacity: 1; 
//             transform: translateY(0); 
//           }
//         }

//         @keyframes bounceIn {
//           0% {
//             opacity: 0;
//             transform: scale(0.8);
//           }
//           60% {
//             opacity: 1;
//             transform: scale(1.05);
//           }
//           100% {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .pulse-element {
//           position: absolute;
//           top: 35%;
//           right: 30%;
//           width: 60px;
//           height: 60px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.06);
//           animation: pulse 3s ease-in-out infinite;
//         }

//         @keyframes pulse {
//           0%, 100% { opacity: 0.3; }
//           50% { opacity: 0.7; }
//         }

//         .profile-wrapper {
//           max-width: 600px;
//           width: 100%;
//           position: relative;
//           z-index: 1;
//         }

//         .profile-card {
//           background: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(20px);
//           border-radius: 24px;
//           padding: 3rem;
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           box-shadow: 0 20px 40px rgba(0,0,0,0.1);
//           animation: bounceIn 0.8s ease-out;
//           position: relative;
//           overflow: hidden;
//         }

//         .profile-card::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           height: 4px;
//           background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
//           border-radius: 24px 24px 0 0;
//         }

//         .profile-header {
//           text-align: center;
//           margin-bottom: 3rem;
//         }

//         .profile-avatar {
//           width: 120px;
//           height: 120px;
//           border-radius: 50%;
//           background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 2.5rem;
//           font-weight: 700;
//           margin: 0 auto 1.5rem;
//           box-shadow: 0 8px 32px rgba(102, 126, 234, 0.4);
//           transition: all 0.3s ease;
//           position: relative;
//         }

//         .profile-avatar:hover {
//           transform: scale(1.05);
//           box-shadow: 0 12px 40px rgba(102, 126, 234, 0.5);
//         }

//         .profile-avatar::after {
//           content: '';
//           position: absolute;
//           inset: -4px;
//           border-radius: 50%;
//           background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
//           z-index: -1;
//           opacity: 0;
//           transition: opacity 0.3s ease;
//         }

//         .profile-avatar:hover::after {
//           opacity: 0.3;
//         }

//         .profile-title {
//           font-size: 2rem;
//           font-weight: 900;
//           color: #1f2937;
//           margin-bottom: 0.5rem;
//         }

//         .profile-subtitle {
//           color: #6b7280;
//           font-size: 1rem;
//           font-weight: 500;
//         }

//         .form-group {
//           margin-bottom: 2rem;
//         }

//         .form-label {
//           display: block;
//           margin-bottom: 0.5rem;
//           font-weight: 600;
//           color: #374151;
//           font-size: 0.95rem;
//         }

//         .form-input {
//           width: 100%;
//           padding: 1.25rem;
//           border: 2px solid rgba(209, 213, 219, 0.3);
//           border-radius: 12px;
//           background: rgba(255, 255, 255, 0.9);
//           backdrop-filter: blur(10px);
//           font-family: inherit;
//           font-size: 1rem;
//           transition: all 0.3s ease;
//           outline: none;
//           box-sizing: border-box;
//         }

//         .form-input:focus:not(:disabled) {
//           border-color: #667eea;
//           box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
//           background: white;
//         }

//         .form-input:disabled {
//           background: rgba(243, 244, 246, 0.5);
//           color: #6b7280;
//           cursor: not-allowed;
//         }

//         .subjects-container {
//           margin: 1.5rem 0;
//         }

//         .subjects-display {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 0.75rem;
//           margin-top: 1rem;
//         }

//         .subject-chip {
//           background: linear-gradient(45deg, #10b981 30%, #059669 90%);
//           color: white;
//           padding: 0.5rem 1rem;
//           border-radius: 20px;
//           font-size: 0.9rem;
//           font-weight: 600;
//           box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
//           animation: slideIn 0.5s ease-out;
//         }

//         .no-subjects {
//           color: #6b7280;
//           font-style: italic;
//           padding: 1rem;
//           text-align: center;
//           background: rgba(243, 244, 246, 0.5);
//           border-radius: 8px;
//           margin-top: 1rem;
//         }

//         .action-buttons {
//           display: flex;
//           justify-content: center;
//           gap: 1rem;
//           margin-top: 3rem;
//         }

//         .btn {
//           padding: 1rem 2rem;
//           border: none;
//           border-radius: 12px;
//           font-weight: 700;
//           font-size: 1rem;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//           min-width: 120px;
//           justify-content: center;
//         }

//         .btn:disabled {
//           opacity: 0.7;
//           cursor: not-allowed;
//           transform: none;
//         }

//         .btn-primary {
//           background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
//           color: white;
//           box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
//         }

//         .btn-primary:hover:not(:disabled) {
//           transform: translateY(-2px);
//           box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
//         }

//         .btn-success {
//           background: linear-gradient(45deg, #10b981 30%, #059669 90%);
//           color: white;
//           box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
//         }

//         .btn-success:hover:not(:disabled) {
//           transform: translateY(-2px);
//           box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
//         }

//         .btn-cancel {
//           background: rgba(239, 68, 68, 0.1);
//           color: #dc2626;
//           border: 2px solid rgba(239, 68, 68, 0.3);
//         }

//         .btn-cancel:hover:not(:disabled) {
//           background: rgba(239, 68, 68, 0.15);
//           transform: translateY(-2px);
//         }

//         .loading-spinner {
//           width: 20px;
//           height: 20px;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-top: 2px solid white;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         .edit-indicator {
//           position: absolute;
//           top: 1rem;
//           right: 1rem;
//           background: rgba(245, 158, 11, 0.1);
//           color: #d97706;
//           padding: 0.5rem 1rem;
//           border-radius: 20px;
//           font-size: 0.8rem;
//           font-weight: 600;
//           border: 1px solid rgba(245, 158, 11, 0.3);
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .snackbar {
//           position: fixed;
//           bottom: 2rem;
//           left: 50%;
//           transform: translateX(-50%);
//           padding: 1rem 2rem;
//           border-radius: 12px;
//           color: white;
//           font-weight: 500;
//           box-shadow: 0 8px 32px rgba(0,0,0,0.3);
//           backdrop-filter: blur(10px);
//           z-index: 1000;
//           animation: slideInFromBottom 0.3s ease-out;
//           display: flex;
//           align-items: center;
//           gap: 0.75rem;
//           max-width: 400px;
//         }

//         .snackbar.success {
//           background: rgba(16, 185, 129, 0.9);
//         }

//         .snackbar.error {
//           background: rgba(239, 68, 68, 0.9);
//         }

//         .snackbar.warning {
//           background: rgba(245, 158, 11, 0.9);
//         }

//         .snackbar.info {
//           background: rgba(59, 130, 246, 0.9);
//         }

//         .snackbar-close {
//           background: none;
//           border: none;
//           color: white;
//           cursor: pointer;
//           padding: 0.25rem;
//           border-radius: 4px;
//           opacity: 0.8;
//         }

//         .snackbar-close:hover {
//           opacity: 1;
//           background: rgba(255, 255, 255, 0.1);
//         }

//         /* Mobile responsiveness */
//         @media (max-width: 768px) {
//           .profile-container {
//             padding: 1rem 0.5rem;
//           }
          
//           .profile-card {
//             padding: 2rem 1.5rem;
//           }

//           .profile-avatar {
//             width: 100px;
//             height: 100px;
//             font-size: 2rem;
//           }

//           .action-buttons {
//             flex-direction: column;
//           }

//           .snackbar {
//             left: 1rem;
//             right: 1rem;
//             transform: none;
//             max-width: none;
//           }
//         }
//       `}</style>

//       <div className="pulse-element"></div>
      
//       <div className="profile-wrapper">
//         <div className="profile-card">
//           {editMode && (
//             <div className="edit-indicator">
//               <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"/>
//               </svg>
//               Edit Mode
//             </div>
//           )}

//           <div className="profile-header">
//             <div className="profile-avatar">
//               {getInitials(formData.username)}
//             </div>
//             <div className="profile-title">Student Profile</div>
//             <div className="profile-subtitle">
//               {editMode ? 'Make changes to your profile information' : 'View and manage your account details'}
//             </div>
//           </div>

//           <form>
//             <div className="form-group">
//               <label className="form-label">Username</label>
//               <input
//                 type="text"
//                 name="username"
//                 className="form-input"
//                 value={formData.username || ""}
//                 onChange={handleChange}
//                 disabled={!editMode}
//                 placeholder="Enter your username"
//               />
//             </div>

//             <div className="form-group">
//               <label className="form-label">Email Address</label>
//               <input
//                 type="email"
//                 name="email"
//                 className="form-input"
//                 value={formData.email || ""}
//                 onChange={handleChange}
//                 // disabled={true}
//                 placeholder="Your email address"
//               />
//             </div>

//             <div className="form-group">
//               <label className="form-label">Department</label>
//               <input
//                 type="text"
//                 name="department"
//                 className="form-input"
//                 value={formData.department || ""}
//                 onChange={handleChange}
//                 disabled={!editMode}
//                 placeholder="Your department"
//               />
//             </div>

//             <div className="subjects-container">
//               <label className="form-label">Subjects</label>
//               {!editMode ? (
//                 <div className="subjects-display">
//                   {formData.subjects?.length > 0 ? (
//                     formData.subjects.map((subject, index) => (
//                       <span key={index} className="subject-chip">
//                         {subject}
//                       </span>
//                     ))
//                   ) : (
//                     <div className="no-subjects">No subjects assigned</div>
//                   )}
//                 </div>
//               ) : (
//                 <input
//                   type="text"
//                   name="subjects"
//                   className="form-input"
//                   value={formData.subjects?.join(", ") || ""}
//                   onChange={(e) =>
//                     setFormData({ 
//                       ...formData, 
//                       subjects: e.target.value.split(",").map((s) => s.trim()).filter(s => s)
//                     })
//                   }
//                   placeholder="Enter subjects separated by commas"
//                 />
//               )}
//             </div>
//           </form>

//           <div className="action-buttons">
//             {!editMode ? (
//               <button 
//                 className="btn btn-primary" 
//                 onClick={() => setEditMode(true)}
//               >
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"/>
//                 </svg>
//                 Edit Profile
//               </button>
//             ) : (
//               <>
//                 <button
//                   className="btn btn-success"
//                   onClick={handleSave}
//                   disabled={saving}
//                 >
//                   {saving ? (
//                     <>
//                       <div className="loading-spinner"></div>
//                       Saving...
//                     </>
//                   ) : (
//                     <>
//                       <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                         <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
//                       </svg>
//                       Save Changes
//                     </>
//                   )}
//                 </button>
//                 <button
//                   className="btn btn-cancel"
//                   onClick={() => {
//                     setFormData(student);
//                     setEditMode(false);
//                   }}
//                   disabled={saving}
//                 >
//                   <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                     <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
//                   </svg>
//                   Cancel
//                 </button>
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Snackbar Notification */}
//       {snackbar.open && (
//         <div className={`snackbar ${snackbar.severity}`}>
//           <span>{snackbar.message}</span>
//           <button className="snackbar-close" onClick={closeSnackbar}>
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
//             </svg>
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Profile() {
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  // Fetch logged-in user details
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
        const res = await axios.get(`${apiUrl}/api/users/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(res.data);
        setFormData(res.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
        setSnackbar({ open: true, message: 'Failed to load profile data.', severity: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  // Handle field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Save profile updates
  const handleSave = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem("token");
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

      const response = await axios.put(
        `${apiUrl}/api/users/update`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setSnackbar({ open: true, message: 'Profile updated successfully!', severity: 'success' });
      setUser(response.data.user);
      setFormData(response.data.user);
      setEditMode(false);
    } catch (error) {
      console.error("Error updating profile:", error);
      setSnackbar({ open: true, message: 'Failed to update profile. Please try again.', severity: 'error' });
    } finally {
      setSaving(false);
    }
  };

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getInitials = (name) => {
    return name
      ? name
          .split(' ')
          .map(word => word.charAt(0).toUpperCase())
          .join('')
          .slice(0, 2)
      : 'U';
  };

  // Determine if user is teacher or student
  const isTeacher = user?.role === 'teacher';
  const profileTitle = isTeacher ? 'Teacher Profile' : 'Student Profile';
  const profileSubtitle = editMode 
    ? 'Make changes to your profile information' 
    : `View and manage your ${isTeacher ? 'teaching' : 'student'} account details`;

  if (loading) {
    return (
      <div className="profile-container">
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
          
          .profile-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          }

          .loading-container {
            text-align: center;
            color: white;
          }

          .loading-spinner {
            width: 48px;
            height: 48px;
            border: 4px solid rgba(255, 255, 255, 0.3);
            border-top: 4px solid white;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 1rem;
          }

          .loading-text {
            font-size: 1.1rem;
            font-weight: 500;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <div className="loading-text">Loading profile...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="profile-container">
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
          
          .profile-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          }

          .error-container {
            text-align: center;
            color: white;
            background: rgba(255, 255, 255, 0.1);
            padding: 3rem;
            border-radius: 16px;
            backdrop-filter: blur(10px);
          }

          .error-icon {
            width: 80px;
            height: 80px;
            background: rgba(239, 68, 68, 0.2);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 1.5rem;
            color: #fca5a5;
          }

          .error-title {
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 0.5rem;
          }

          .error-message {
            font-size: 1rem;
            opacity: 0.9;
          }
        `}</style>
        <div className="error-container">
          <div className="error-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"/>
            </svg>
          </div>
          <div className="error-title">Profile Not Found</div>
          <div className="error-message">Unable to load your profile information. Please try refreshing the page.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .profile-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .profile-container::before {
          content: '';
          position: absolute;
          top: 15%;
          right: 10%;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: float 4s ease-in-out infinite;
        }

        .profile-container::after {
          content: '';
          position: absolute;
          bottom: 20%;
          left: 12%;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 3.5s ease-in-out infinite;
          animation-delay: 1.8s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(8deg); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes slideInFromBottom {
          from { 
            opacity: 0; 
            transform: translateY(100px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }

        @keyframes bounceIn {
          0% {
            opacity: 0;
            transform: scale(0.8);
          }
          60% {
            opacity: 1;
            transform: scale(1.05);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        .pulse-element {
          position: absolute;
          top: 35%;
          right: 30%;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.06);
          animation: pulse 3s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 0.7; }
        }

        .profile-wrapper {
          max-width: 600px;
          width: 100%;
          position: relative;
          z-index: 1;
        }

        .profile-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 3rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          animation: bounceIn 0.8s ease-out;
          position: relative;
          overflow: hidden;
        }

        .profile-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
          border-radius: 24px 24px 0 0;
        }

        .profile-header {
          text-align: center;
          margin-bottom: 3rem;
        }

        .profile-avatar {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2.5rem;
          font-weight: 700;
          margin: 0 auto 1.5rem;
          box-shadow: 0 8px 32px rgba(102, 126, 234, 0.4);
          transition: all 0.3s ease;
          position: relative;
        }

        .profile-avatar.teacher {
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          box-shadow: 0 8px 32px rgba(16, 185, 129, 0.4);
        }

        .profile-avatar:hover {
          transform: scale(1.05);
          box-shadow: 0 12px 40px rgba(102, 126, 234, 0.5);
        }

        .profile-avatar.teacher:hover {
          box-shadow: 0 12px 40px rgba(16, 185, 129, 0.5);
        }

        .profile-avatar::after {
          content: '';
          position: absolute;
          inset: -4px;
          border-radius: 50%;
          background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
          z-index: -1;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .profile-avatar:hover::after {
          opacity: 0.3;
        }

        .profile-title {
          font-size: 2rem;
          font-weight: 900;
          color: #1f2937;
          margin-bottom: 0.5rem;
        }

        .profile-subtitle {
          color: #6b7280;
          font-size: 1rem;
          font-weight: 500;
        }

        .form-group {
          margin-bottom: 2rem;
        }

        .form-label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: #374151;
          font-size: 0.95rem;
        }

        .form-input {
          width: 100%;
          padding: 1.25rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          transition: all 0.3s ease;
          outline: none;
          box-sizing: border-box;
        }

        .form-input:focus:not(:disabled) {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          background: white;
        }

        .form-input:disabled {
          background: rgba(243, 244, 246, 0.5);
          color: #6b7280;
          cursor: not-allowed;
        }

        .subjects-container {
          margin: 1.5rem 0;
        }

        .subjects-display {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-top: 1rem;
        }

        .subject-chip {
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.9rem;
          font-weight: 600;
          box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
          animation: slideIn 0.5s ease-out;
        }

        .subject-chip.teacher {
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
        }

        .no-subjects {
          color: #6b7280;
          font-style: italic;
          padding: 1rem;
          text-align: center;
          background: rgba(243, 244, 246, 0.5);
          border-radius: 8px;
          margin-top: 1rem;
        }

        .action-buttons {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin-top: 3rem;
        }

        .btn {
          padding: 1rem 2rem;
          border: none;
          border-radius: 12px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          min-width: 120px;
          justify-content: center;
        }

        .btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .btn-primary {
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          color: white;
          box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
        }

        .btn-primary:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
        }

        .btn-success {
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          color: white;
          box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3);
        }

        .btn-success:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
        }

        .btn-cancel {
          background: rgba(239, 68, 68, 0.1);
          color: #dc2626;
          border: 2px solid rgba(239, 68, 68, 0.3);
        }

        .btn-cancel:hover:not(:disabled) {
          background: rgba(239, 68, 68, 0.15);
          transform: translateY(-2px);
        }

        .loading-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .edit-indicator {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: rgba(245, 158, 11, 0.1);
          color: #d97706;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          border: 1px solid rgba(245, 158, 11, 0.3);
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .snackbar {
          position: fixed;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          padding: 1rem 2rem;
          border-radius: 12px;
          color: white;
          font-weight: 500;
          box-shadow: 0 8px 32px rgba(0,0,0,0.3);
          backdrop-filter: blur(10px);
          z-index: 1000;
          animation: slideInFromBottom 0.3s ease-out;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          max-width: 400px;
        }

        .snackbar.success {
          background: rgba(16, 185, 129, 0.9);
        }

        .snackbar.error {
          background: rgba(239, 68, 68, 0.9);
        }

        .snackbar.warning {
          background: rgba(245, 158, 11, 0.9);
        }

        .snackbar.info {
          background: rgba(59, 130, 246, 0.9);
        }

        .snackbar-close {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 4px;
          opacity: 0.8;
        }

        .snackbar-close:hover {
          opacity: 1;
          background: rgba(255, 255, 255, 0.1);
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .profile-container {
            padding: 1rem 0.5rem;
          }
          
          .profile-card {
            padding: 2rem 1.5rem;
          }

          .profile-avatar {
            width: 100px;
            height: 100px;
            font-size: 2rem;
          }

          .action-buttons {
            flex-direction: column;
          }

          .snackbar {
            left: 1rem;
            right: 1rem;
            transform: none;
            max-width: none;
          }
        }
      `}</style>

      <div className="pulse-element"></div>
      
      <div className="profile-wrapper">
        <div className="profile-card">
          {editMode && (
            <div className="edit-indicator">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"/>
              </svg>
              Edit Mode
            </div>
          )}

          <div className="profile-header">
            <div className={`profile-avatar ${isTeacher ? 'teacher' : ''}`}>
              {getInitials(formData.username)}
            </div>
            <div className="profile-title">{profileTitle}</div>
            <div className="profile-subtitle">{profileSubtitle}</div>
          </div>

          <form>
            <div className="form-group">
              <label className="form-label">Username</label>
              <input
                type="text"
                name="username"
                className="form-input"
                value={formData.username || ""}
                onChange={handleChange}
                disabled={!editMode}
                placeholder="Enter your username"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                name="email"
                className="form-input"
                value={formData.email || ""}
                onChange={handleChange}
                disabled={!editMode}
                placeholder="Your email address"
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                {isTeacher ? 'Department/Faculty' : 'Department'}
              </label>
              <input
                type="text"
                name="department"
                className="form-input"
                value={formData.department || ""}
                onChange={handleChange}
                disabled={!editMode}
                placeholder={isTeacher ? "Your teaching department" : "Your department"}
              />
            </div>

            {/* Teacher-specific fields */}
            {isTeacher && (
              <>
                {/* <div className="form-group">
                  <label className="form-label">Employee ID</label>
                  <input
                    type="text"
                    name="employeeId"
                    className="form-input"
                    value={formData.employeeId || ""}
                    onChange={handleChange}
                    disabled={!editMode}
                    placeholder="Your employee ID"
                  />
                </div> */}

                {/* <div className="form-group">
                  <label className="form-label">Designation</label>
                  <input
                    type="text"
                    name="designation"
                    className="form-input"
                    value={formData.designation || ""}
                    onChange={handleChange}
                    disabled={!editMode}
                    placeholder="Your designation (e.g., Professor, Assistant Professor)"
                  />
                </div> */}

                {/* <div className="form-group">
                  <label className="form-label">Office Room</label>
                  <input
                    type="text"
                    name="officeRoom"
                    className="form-input"
                    value={formData.officeRoom || ""}
                    onChange={handleChange}
                    disabled={!editMode}
                    placeholder="Your office room number"
                  />
                </div> */}

                {/* <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    className="form-input"
                    value={formData.phone || ""}
                    onChange={handleChange}
                    disabled={!editMode}
                    placeholder="Your contact number"
                  />
                </div> */}
              </>
            )}

            {/* Student-specific fields */}
            {!isTeacher && (
              <>
                <div className="form-group">
                  <label className="form-label">Student ID</label>
                  <input
                    type="text"
                    name="studentId"
                    className="form-input"
                    value={formData.studentId || ""}
                    onChange={handleChange}
                    disabled={!editMode}
                    placeholder="Your student ID"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Year/Semester</label>
                  <input
                    type="text"
                    name="yearSemester"
                    className="form-input"
                    value={formData.yearSemester || ""}
                    onChange={handleChange}
                    disabled={!editMode}
                    placeholder="e.g., 2nd Year, 4th Semester"
                  />
                </div>
              </>
            )}

            <div className="subjects-container">
              <label className="form-label">
                {isTeacher ? 'Teaching Subjects' : 'Enrolled Subjects'}
              </label>
              {!editMode ? (
                <div className="subjects-display">
                  {formData.subjects?.length > 0 ? (
                    formData.subjects.map((subject, index) => (
                      <span key={index} className={`subject-chip ${isTeacher ? 'teacher' : ''}`}>
                        {subject}
                      </span>
                    ))
                  ) : (
                    <div className="no-subjects">
                      {isTeacher ? 'No teaching subjects assigned' : 'No subjects enrolled'}
                    </div>
                  )}
                </div>
              ) : (
                <input
                  type="text"
                  name="subjects"
                  className="form-input"
                  value={formData.subjects?.join(", ") || ""}
                  onChange={(e) =>
                    setFormData({ 
                      ...formData, 
                      subjects: e.target.value.split(",").map((s) => s.trim()).filter(s => s)
                    })
                  }
                  placeholder="Enter subjects separated by commas"
                />
              )}
            </div>
          </form>

          <div className="action-buttons">
            {!editMode ? (
              <button 
                className="btn btn-primary" 
                onClick={() => setEditMode(true)}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"/>
                </svg>
                Edit Profile
              </button>
            ) : (
              <>
                <button
                  className="btn btn-success"
                  onClick={handleSave}
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <div className="loading-spinner"></div>
                      Saving...
                    </>
                  ) : (
                    <>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
                      </svg>
                      Save Changes
                    </>
                  )}
                </button>
                <button
                  className="btn btn-cancel"
                  onClick={() => {
                    setFormData(user);
                    setEditMode(false);
                  }}
                  disabled={saving}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
                  </svg>
                  Cancel
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Snackbar Notification */}
      {snackbar.open && (
        <div className={`snackbar ${snackbar.severity}`}>
          <span>{snackbar.message}</span>
          <button className="snackbar-close" onClick={closeSnackbar}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}